import { useEffect, useRef, useState } from 'react';
import apiClient from '../utils/api';
import { TeamForm } from '../components/TeamFormIndicator';

export function useTeamForms(teamIds: string[], enabled = true) {
  const [teamForms, setTeamForms] = useState<Record<string, TeamForm>>({});
  const lastFetchedTeamIdsRef = useRef<string>('');

  useEffect(() => {
    const fetchTeamForms = async () => {
      if (!enabled || teamIds.length === 0) {
        return;
      }

      const teamIdsKey = teamIds.join(',');

      if (lastFetchedTeamIdsRef.current === teamIdsKey) {
        return;
      }

      try {
        const response = await apiClient.post('/teams/form/batch', {
          teamIds,
          limit: 5,
        });

        setTeamForms(response.data);
        lastFetchedTeamIdsRef.current = teamIdsKey;
      } catch (err) {
        console.warn('Failed to fetch team forms:', err);
      }
    };

    fetchTeamForms();
  }, [enabled, teamIds]);

  return teamForms;
}
